const GlobalStyle = {
    global: () => ({
        "html, body": {
            color: "#333333",
            height: "100%",
            scrollbarColor: "#000000 transparent",
            scrollbarWidth: "thin",
            backgroundColor: "#FFFFFF",
        },
        ".btn-icon-lg": {
            justifyContent: "center !important",
            padding: "0.75rem !important",
            width: "unset !important",
        },
        ".btn-icon, .btn-icon-md": {
            justifyContent: "center !important",
            padding: "0.625rem !important",
            width: "unset !important",
        },
        ".btn-icon-sm": {
            justifyContent: "center !important",
            padding: "0.5rem !important",
            width: "unset !important",
        },
        ".btn-icon-xs": {
            justifyContent: "center !important",
            padding: "0.325rem !important",
            width: "unset !important",
        },
        ".btn-input-icon, .btn-input-icon-md": {
            justifyContent: "center !important",
            padding: "0.200rem !important",
        },
        ".close-dropdown": {
            display: "none !important",
        },
        ".rotate-180": {
            transform: "rotate(180deg)",
        },
        ".btn-icon-header": {
            width: "1.25rem !important",
            height: "1.25rem !important",
            justifyContent: "center !important",
            padding: "0.1rem !important",
        },
        ".chakra-input__group": {
            minWidth: "unset !important",
        },
    }),
};

export default GlobalStyle;
